import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "value", "type", "inputSize", "name", "id", "placeholder", "error", "error_message", "disabled", "center", "inputClassname", "EndIcon", "onClear", "currencyInputProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { XIcon } from '@heroicons/react/outline';
import CurrencyInput from 'react-currency-input-field';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Input = /*#__PURE__*/forwardRef(function Input(props, ref) {
  var label = props.label,
      value = props.value,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      inputSize = props.inputSize,
      name = props.name,
      id = props.id,
      placeholder = props.placeholder,
      error = props.error,
      error_message = props.error_message,
      disabled = props.disabled,
      center = props.center,
      inputClassname = props.inputClassname,
      _props$EndIcon = props.EndIcon,
      EndIcon = _props$EndIcon === void 0 ? null : _props$EndIcon,
      onClear = props.onClear,
      currencyInputProps = props.currencyInputProps,
      passThroughProps = _objectWithoutProperties(props, _excluded);

  var focusClass = error ? 'focus-within:border-red-500 focus-within:ring-red-500 border-red-500' : 'focus-within:border-black focus-within:ring-black';
  return /*#__PURE__*/_jsxs("div", {
    className: passThroughProps.className,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "relative flex rounded-md border border-gray-300 bg-white px-1 text-sm ".concat(focusClass, "  ").concat(label ? 'pt-4' : '', " ").concat(disabled ? 'opacity-50' : '', " ").concat(error ? 'border-red' : ''),
      children: [type !== 'currency' && /*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({}, passThroughProps), {}, {
        value: value,
        ref: ref,
        type: type,
        name: name,
        id: id,
        disabled: disabled,
        className: "numeric-font-fix peer w-full border-0 font-medium text-gray-900 focus:outline-none focus:ring-0 ".concat(center ? 'text-center' : 'text-left', " ").concat(label ? 'placeholder-transparent' : '', " ").concat(inputSize === 'sm' ? 'h-9 text-base placeholder:text-sm' : 'h-12', " ").concat(disabled ? 'pointer-events-none cursor-not-allowed' : 'cursor-auto', " ").concat(inputClassname),
        placeholder: label || placeholder,
        inputMode: type === 'number' ? 'numeric' : undefined
      })), type === 'currency' && /*#__PURE__*/_jsx(CurrencyInput, _objectSpread(_objectSpread({}, currencyInputProps), {}, {
        value: value,
        ref: ref,
        name: name,
        id: id,
        disabled: disabled,
        className: "numeric-font-fix peer w-full border-0 font-medium text-gray-900 focus:outline-none focus:ring-0 ".concat(center ? 'text-center' : 'text-left', " ").concat(label ? 'placeholder-transparent' : '', " ").concat(inputSize === 'sm' ? 'h-9 text-base placeholder:text-sm' : 'h-12', " ").concat(inputClassname),
        placeholder: label || placeholder,
        onChange: passThroughProps.onChange,
        onBlur: passThroughProps.onBlur
      })), onClear && !disabled && /*#__PURE__*/_jsx("button", {
        type: "button",
        className: "hover:text-brand-primary mr-1 text-black/70 transition-colors ".concat(value ? '' : 'opacity-0'),
        onClick: function onClick(e) {
          if (!value) return;
          e.preventDefault();
          e.stopPropagation();
          onClear();
        },
        children: /*#__PURE__*/_jsx(XIcon, {
          className: "w-5"
        })
      }), EndIcon && /*#__PURE__*/_jsx(EndIcon, {
        className: "mr-2 w-5 text-black/60"
      }), label && /*#__PURE__*/_jsx("label", {
        htmlFor: name,
        className: "".concat(inputSize === 'sm' ? 'text-xs peer-placeholder-shown:top-4' : 'text-sm  peer-placeholder-shown:top-5', " origin-0 -z-1 pointer-events-none absolute left-4 top-2 block text-gray-600 transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:top-2 peer-focus:text-xs peer-focus:text-gray-600"),
        children: label
      })]
    }), error && /*#__PURE__*/_jsx("p", {
      className: "text-red-error mt-2 text-xs font-bold italic leading-3",
      children: error_message
    })]
  });
});
export default Input;